const apiUrl = process.env.REACT_APP_API_URL;
export const UpdateStock = async ( id_ingredient : number, quantitat : number, page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8072/stock`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({id_ingredient, quantitat})
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};